"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var _componentsBase = require("@telus-uds/components-base");
/**
 * Returns object with `renderApp` and `getStyles` functions.
 * Weave these into your app's server-side render process:
 *
 * - Call `renderApp` first to do the actual server-side render
 * - After the render is complete, call `getStyles`
 * - Include the style tags returned by `getStyles` in the SSR <head>
 *
 * This wraps ssrStyles from @telus-uds/components-base and adds Styled Components support.
 *
 * @param {string} [appName] - optional unique identifier if ssrStyles is called multiple times for multiple apps
 * @param {object} [options] -
 *  - `styleGetters`: optional array of additional style getter functions to call after render
 *  - `collectStyles`: optional function, takes the rendered app, returns either the same or a new app element
 * @param {boolean} [options.styleGetters]
 * @param {(ReactElement) => ReactElement} [options.collectStyles]
 */
const ssrStyles = function () {
  let appName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Allium app';
  let {
    styleGetters = [],
    collectStyles = renderedApp => renderedApp
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let router = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'pages';
  const sheet = new _styledComponents.ServerStyleSheet();
  const getStyledComponentsStyles = () => {
    const styles = sheet.getStyleElement();
    sheet.seal();
    return styles;
  };
  if (router === 'app') {
    return (0, _componentsBase.ssrStyles)(appName, {
      styleGetters: [...styleGetters],
      collectStyles
    });
  }
  return (0, _componentsBase.ssrStyles)(appName, {
    styleGetters: [getStyledComponentsStyles, ...styleGetters],
    collectStyles: renderedApp => collectStyles(sheet.collectStyles(renderedApp))
  });
};
var _default = exports.default = ssrStyles;